export default __webpack_public_path__ + "static/media/google_logo.e1102c4b.png";